export default "__VITE_ASSET__048b1eb4__"